import { Instagram, Facebook, Youtube } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import faviconIcon from "@/assets/favicon-icon.ico";
import logoHorizontal from "@/assets/escrituria-logo-horizontal.png";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (sectionId: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        element?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contato" className="bg-primary text-primary-foreground py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4 flex flex-col items-center md:items-start">
            <button onClick={() => navigate('/')} className="flex flex-col items-center gap-3 cursor-pointer">
              <img src={faviconIcon} alt="EscriturIA" className="w-10 h-10 object-contain" />
              <img src={logoHorizontal} alt="EscriturIA" className="h-14 w-auto object-contain" />
            </button>
          </div>

          {/* Links - aligned with reference */}
          <div className="text-center md:text-left">
            <h3 className="font-semibold mb-4 text-secondary">Recursos</h3>
            <ul className="space-y-2 text-sm flex flex-col items-center md:items-start">
              <li>
                <a
                  href="https://www.youtube.com/@falaescrituria"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-foreground/80 hover:text-secondary transition-colors"
                >
                  Vídeos Tutoriais
                </a>
              </li>
            </ul>
          </div>

          <div className="text-center md:text-left">
            <h3 className="font-semibold mb-4 text-secondary">Empresa</h3>
            <ul className="space-y-2 text-sm flex flex-col items-center md:items-start">
              <li>
                <button onClick={() => navigate('/sobre-nos')} className="text-primary-foreground/80 hover:text-secondary transition-colors">
                  Sobre Nós
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/compromissos')} className="text-primary-foreground/80 hover:text-secondary transition-colors">
                  Compromissos
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center md:text-left">
            <h3 className="font-semibold mb-4 text-secondary">Conecte-se</h3>
            <div className="flex gap-4 justify-center md:justify-start">
              <a
                href="https://www.instagram.com/falaescrituria"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-secondary hover:text-primary transition-all"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.facebook.com/falaescrituria"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-secondary hover:text-primary transition-all"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.youtube.com/@falaescrituria"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-secondary hover:text-primary transition-all"
                aria-label="YouTube"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar - aligned with reference */}
        <div className="pt-8 border-t border-primary-foreground/20 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-primary-foreground/60">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 flex-wrap justify-center md:justify-start text-center md:text-left">
            <p>© {new Date().getFullYear()} EscriturIA. Todos os direitos reservados.</p>
            <span className="hidden sm:inline">•</span>
            <div className="flex items-center gap-1">
              <span className="hidden sm:inline">developed by</span>
              <a
                href="https://niginex.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity duration-150 flex items-center ml-1"
              >
                <img
                  src="/imgs/logos/niginex-logo-lab-negativo.png?v=2"
                  alt="RCA Tecnologia Ltda - niginex LAB"
                  className="h-4 md:h-5 w-auto"
                />
              </a>
              <span className="mx-1">&</span>
              <img
                src="/imgs/logos/logo-escriturai-rodape-dark.png"
                alt="EscriturIA"
                className="h-[0.6rem] md:h-[0.75rem] w-auto"
              />
            </div>
          </div>
          <div className="flex items-center gap-3 md:gap-6">
            <Link
              to="/termos-de-uso"
              className="hover:text-secondary transition-colors"
            >
              Termos de Uso
            </Link>
            <Link
              to="/politica-de-privacidade"
              className="hover:text-secondary transition-colors"
            >
              Política de Privacidade
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
